export default function Contact () {
    return(
        <div className="contact">
            <div className='text-2xl pt-20'>
            <br />
            <br />
            <h1 className='text-[#4CAF50]'>Contact</h1>
            <br />
            <h2><a href="tel:941-268-1926">Phone: 941-268-1926</a></h2>
            <br />
            <h3><a href="mailto:gmswan99@gmail.com">gmswan99@gmail.com</a></h3>  
           
            
            </div>
        
        </div>

    )
}